import { render, staticRenderFns } from "./IncomingTariffs.vue?vue&type=template&id=cd74f4a4&"
import script from "./IncomingTariffs.vue?vue&type=script&lang=ts&"
export * from "./IncomingTariffs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports